<template>
    <div>
        <Modal v-model="visible" :title="!formData.id ? '新增' : '编辑'" width="800" class="my-modal top" :mask-closable="false"
            :footer-hide="true">
            <Form v-if="showPupUp" ref="form" :model="formData" class="page-form less" :label-width="90">
                <FormItem label="基本法名称" prop="name">
                    <Input disabled v-model="formData.baseName" />
                </FormItem>
                <FormItem label="人员级别" prop="rankId" :rules="$units.formRule.required('请选择')">
                    <Select clearable v-model="formData.rankId" transfer filterable>
                        <Option v-for="item in baseRankList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <p class="item">
                    <Checkbox v-model="all" @on-change="changeAll">全选</Checkbox>
                </p>
                <div v-for="(item, index) in baseCommissionList" :key="item.sortCode">
                    <p class="item">
                        <Checkbox v-model="item.checkAll" @on-change="changeItemAll(item.checkAll, index)"><b>{{
                            item.sortName }}</b></Checkbox>
                    </p>
                    <p class="item">
                        <CheckboxGroup v-model="item.checkArr" @on-change="checkStatus">
                            <Checkbox :label="i.id" v-for="i in item.commissionList" :key="i.id">
                                <span>{{ i.name }}
                                    <Tooltip v-if="i.ruleName" placement="top-start" transfer>

                                        <template #content>
                                            <div v-html="i.ruleName"></div>

                                        </template>
                                        <Icon type="ios-help-circle-outline" />
                                    </Tooltip>
                                </span>
                            </Checkbox>
                        </CheckboxGroup>
                    </p>
                </div>
            </Form>
            <div class="ivu-modal-footer">
                <Button type="text" @click="visible = false">取消</Button>
                <Button type="primary" @click="save">确认</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import filter from '@/api/filter';
import selectTree from '@/components/system/selectTree3';
export default {
    props: ['initList'],
    components: { selectTree },
    data() {
        return {
            baseCommissionList: [],
            all: false,//全选
            managerAll: false,
            personAll: false,
            filter,
            visible: false,
            showPupUp: false,
            baseRankList: [],
            personArr: [],
            managerArr: [],
            formData: {
                id: '',
                rankId: '',
                baseName: '',
                selected: []
            },
        };
    },
    methods: {
        changeAll(val) {
            this.baseCommissionList.forEach(item => {
                item.checkAll = val;
                if (val) {
                    item.checkArr = item.commissionList.map(i => i.id)

                } else {
                    item.checkArr = []
                }
            })

        },
        checkStatus() {
            this.all = this.baseCommissionList.forEach(item => {
                item.checkAll = item.checkArr.length == item.commissionList.length
            })
            this.all = this.baseCommissionList.every(item => {
                return item.checkArr.length == item.commissionList.length;
            })

        },
        changeItemAll(val, index) {
            if (val) {
                this.baseCommissionList[index].checkArr = this.baseCommissionList[index].commissionList.map(i => i.id)
            } else {
                this.baseCommissionList[index].checkArr = []
            }
            this.checkStatus()
        },
        async open(data = {}) {
            this.visible = true;
            this.showPupUp = true;
            let res = await this.getBaseCommission()
            this.baseCommissionList = res.data.map(item => {
                return {
                    ...item,
                    checkAll: false,
                    checkArr: []
                }
            })
            if (data.id) {
                this.formData.id = data.id;
                this.getDetail();
            }
            this.formData = data;
            this.getBaseRank()
            this.$refs.form && this.$refs.form.resetFields();
        },
        getDetail() {
            this.$http({
                url: '/buz/baseCommissionJoin/read/detail',
                type: 'GET',
                data: {
                    id: this.formData.id
                }
            }).then(res => {
                if (res.data.selected.length) {
                    this.baseCommissionList.forEach(item => {
                        item.checkArr = item.commissionList.filter(i => res.data.selected.includes(i.id)).map(i => i.id)
                        item.checkAll = item.commissionList.every(i => res.data.selected.includes(i.id))
                    })
                }
                this.formData = res.data;
            });
        },
        //获取利益项
        getBaseCommission() {
            return this.$http({
                url: '/buz/baseCommission/getBaseCommission',
                type: 'GET',
                data: {
                    type: 1
                }
            })
        },
        //获取职级
        getBaseRank() {
            this.$http({
                url: '/buz/baseRank/read/all',
                type: 'POST',
                data: {}
            }).then(res => {
                this.baseRankList = res.data;
            });
        },
        save() {
            this.$refs.form.validate().then(isok => {
                if (!isok) {
                    return;
                }
                let selected = []
                this.baseCommissionList.forEach(item => {
                    console.log(item.checkArr)
                    selected.push(item.checkArr)
                })
                let data = {
                    ...this.formData,
                    selected: selected.reduce(function (a, b) {
                        return a.concat(b);
                    })
                };
                console.log(data);
                this.$http({
                    url: this.formData.id ? '/buz/baseCommissionJoin/edit' : '/buz/baseCommissionJoin/add',
                    type: 'POST',
                    data
                }).then(res => {
                    this.formData = {};
                    this.initList();
                    this.$notice.success('操作成功');
                    this.visible = false;
                });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.my-modal {
    /deep/ {
        .ivu-modal-body {
            padding-top: 0;
        }

        .ivu-checkbox-wrapper {
            margin-right: 12px;
            width: 30%;

            .ivu-icon-ios-help-circle-outline {
                font-weight: 600;
                font-size: 16px;
            }
        }
    }

    .item {
        margin: 0 0 20px 0;
    }
}
</style>
